var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_flex",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm._l(_vm.primaryActions, function (action, index) {
        return _c(
          "tooltip",
          {
            key: index,
            staticClass: "_flex _ml-1",
            attrs: { text: action.label },
          },
          [
            _c(
              "base-button",
              {
                attrs: {
                  shape: "circle",
                  theme: _vm.getTheme(action.theme),
                  enabled: _vm.getEnabledStatus(action.enabled),
                  "data-qa": `context-action:${action.qa}`,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return action.fn.apply(null, arguments)
                  },
                },
              },
              [_c("base-icon", { attrs: { name: action.iconName } })],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.hasSecondaryActions
        ? [
            _c("click-outside", { attrs: { call: _vm.onBalloonClose } }, [
              _c(
                "div",
                { staticClass: "_pos-r _ml-1" },
                [
                  _c(
                    "base-button",
                    {
                      ref: "trigger",
                      attrs: {
                        shape: "circle",
                        theme: _vm.defaultButtonTheme,
                        "data-qa": `context-action:Open`,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onBalloonToggle.apply(null, arguments)
                        },
                      },
                    },
                    [_c("base-icon", { attrs: { name: "ellipsis-v" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isSecondaryActionVisible
                    ? _c(
                        "base-balloon",
                        _vm._b(
                          {
                            style: _vm.balloonStyles,
                            attrs: {
                              anchor: "fixed",
                              direction: _vm.direction,
                              position: "center",
                              "show-header": false,
                              "data-qa": "context-action-balloon:Content",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content",
                                  fn: function () {
                                    return _vm._l(
                                      _vm.secondaryActions,
                                      function (action, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "gfu-balloon__content-link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onBalloonAction(
                                                  action.fn
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("base-icon", {
                                              staticClass:
                                                "gfu-balloon__content-icon",
                                              attrs: { name: action.iconName },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  "data-qa": `context-action-link:${action.qa}`,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(action.label) +
                                                    "\n                            "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    )
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1651355418
                            ),
                          },
                          "base-balloon",
                          _vm.balloonProps,
                          false
                        )
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }